export function appSettingEnabled(settings, category, key) {
  return settings?.appSettings?.find((setting) => {
    return setting.category === category && setting.key === key && setting.value === "t"
  });
}
export function appFlipperEnabled(settings, name) {
  return appSettingEnabled(settings, "flipper", name);
}
